export default {
  'component.takst.title': 'Takst',
  'component.takst.description': 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.',
  'component.takst.addtakst': 'Legg til Takst',
  'component.takst.edittakst': 'Rediger Takst',
  'component.takst.tablesearch': 'Søk etter navn, e-post, telefon, eiendomsadresse og postnummer',
  'component.takst.deletemodal.title': 'Slett Takst',
  'component.takst.deletemodal.text': 'Er du sikker på at du vil slette denne Takst?',
};
